(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["preloader"]) return;
  try {
    
  window.addEventListener("load", (event) => {
    let timeout = 1000
    if(window.screen.width < 769) {
      timeout = 1500
    }
    setTimeout(() => {
      fadeOutEffect('status')
      fadeOutEffect('preloader')
      document.querySelector('body').style.overflow = 'visible'
    }, timeout)
  });
    function fadeOutEffect(id) {
    const fadeTarget = document.getElementById(id);
    const fadeEffect = setInterval(function () {
        if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
        }
        if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.2;
        } else {
            fadeTarget.style.display = 'none'
            clearInterval(fadeEffect);
        }
    }, 100);
}

  } catch(e) { console.error(e); }
})();
})();
